let housekeeper = {
    path: "housekeeper",
    name: "housekeeper",
    redirect: "/housekeeper/list",
    component: () => import("@/views/housekeeper/index.vue"),
    meta: {
      name: "家政员",
    },
    children: [
      {
        path: "list",
        name: "houselist",
        component: () => import("@/views/housekeeper/pages/index.vue"),
        meta: {
          name: "家政员",
        }
      },
      {
        path: "detail",
        name: "housedetail",
        component: () => import("@/views/housekeeper/pages/detail.vue"),
        meta: {
          name: "家政员详情",
        }
      },
    ],
  };
  
  export default housekeeper;